import script from "./TeacherWrongQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeacherWrongQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./TeacherWrongQuestion.vue?vue&type=style&index=0&id=1fc5caf2&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc5caf2"]])

export default __exports__